import { css } from "lit-element";

import { InputCheckboxStyle } from "@stofloos/components/atoms/inputs/input-checkbox";
import { InputRadioboxStyle } from "@stofloos/components/atoms/inputs/input-radiobox";
import { InputCheckboxListStyle } from "@stofloos/components/atoms/inputs/input-checkbox-list";
import { StofwareColors } from "@stofloos/globals/styles/colors";
import { StofwareText } from "@stofloos/globals/styles/typography";
import { LayoutFlex } from "@stofloos/globals/styles/layout-flex";
import { StofwareAccordion } from "@stofloos/globals/styles/accordion";

export const style = css`
	input-checkbox,
	input-radiobox {
		margin: 5px 15px;
	}

	input-checkbox {
		padding: 20px 0;
		width: auto;
		min-width: calc(20% - 30px);
	}

	color-picker,
	rich-editor,
	input-checkbox-list,
	input-select,
	input-simple,
	input-default {
		padding: 5px 15px;
		min-width: calc(20% - 30px);
		box-sizing: border-box;
	}

	.col-6 input-checkbox-list,
	.col-6 input-select,
	.col-6 input-default {
		width: calc(50% - 30px);
	}

	json-editor,
	input-textarea {
		margin: 5px 15px;
	}

	.text-sm h3 {
		font-size: 0.83em;
	}

	.text-md h3 {
		font-size: 1em;
	}

	.text-lg h3 {
		font-size: 1.5em;
	}

	.text-xl h3 {
		font-size: 2em;
	}

	h3,
	h4,
	h5,
	h6,
	.description {
		margin: 15px;
	}

	.mt-1 {
		margin-top: 10px;
	}

	.mr-auto {
		margin-right: auto;
	}

	.ml-auto {
		margin-left: auto;
	}

	.mx-0 h3,
	.mx-0 h4,
	.mx-0 h5,
	.mx-0 h6,
	.mx-0 .description {
		margin: 0 15px;
	}

	input-checkbox.title {
		margin: 13px 0;
		width: auto;
		height: 24px;
	}

	input-select[readonly] > input-md-decorator > input-underline,
	input-default[readonly] > input-md-decorator > input-underline {
		display: none;
	}

	input-select[readonly] input-md-decorator,
	input-default[readonly] input-md-decorator {
		border-color: #ffffff;
	}

	input-select[readonly] input-md-decorator > label,
	input-default[readonly] input-md-decorator > label {
		transform: translate3d(0px, -3.4em, 0px) scale(0.7, 0.7);
		opacity: 1;
	}
	icon {
		margin: 20px;
	}
	icon svg {
		display: block;
		width: 16px;
		margin: 5px 0;
		fill: var(--app-bluegrey);
	}

	.accordion > .accordion-title {
		border-left: 5px solid transparent;
	}

	.accordion > .accordion-title.completed {
		border-left-color: var(--app-success);
	}

	.accordion > .accordion-title > .icon-down,
	.accordion.active > .accordion-title > .icon-up {
		display: block;
	}

	.accordion > .accordion-title > .icon-up,
	.accordion.active > .accordion-title > .icon-down {
		display: none;
	}

	input-dropzone-file {
		position: relative;
		border: 2px dashed var(--app-grey);
		background-color: var(--app-lightgrey);

		padding: 10px;
		font-size: 16px;
		text-align: center;
		width: calc(20% - 30px);
	}

	input-dropzone-file > icon svg {
		margin: auto;
		width: 32px;
		height: 32px;
	}

	input-dropzone-file > input {
		height: 100%;
		width: 100%;
		position: absolute;
		top: 0;
		right: 0;
		margin: 0;
		padding: 0;
		font-size: 20px;
		cursor: pointer;
		opacity: 0;
		filter: alpha(opacity=0);
	}

	.toggle-element {
		display: none;
	}
	.toggle-element.active {
		display: block;
	}

	.layout .float-left {
		display: block;
		float: left;
	}
	
	.w-20 {
		min-width: 20%;
		width: 20%;
	}

	.w-25 {
		min-width: 25%;
		width: 25%;
	}

	.w-33 {
		min-width: 33%;
		width: 33%;
	}

	.w-50 {
		width: 50%;
	}

	.w-100 {
		display: block;
		width: 100%;
	}

	.sw-form-summary-item {
		margin: 10px 15px;

		cursor: pointer;
		height: 46px;
		line-height: 46px;
		margin-bottom: 5px;
		background-color: var(--app-lightgrey);
		text-overflow: ellipsis;
		flex-wrap: wrap;
		padding: 0px 20px;
		border-radius: 5px;
	}
	
	.sw-form-summary-item-label {
		margin-right: 20px;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}
	
	.sw-form-summary-item-content {
		margin: 0px 20px;
	}
	
	.sw-form-summary-item sw-icon {
		line-height: 46px;
	}

	@media only screen and (max-width: 768px) {
		.w-20 {
			min-width: 50%;
			width: 50%;
		}

		.w-25 {
			min-width: 50%;
			width: 50%;
		}

		.w-33 {
			min-width: 50%;
			width: 50%;
		}
	}
`;

export const styles = [
	LayoutFlex,
	StofwareColors,
	StofwareText,
	StofwareAccordion,
	InputCheckboxListStyle,
	InputCheckboxStyle,
	InputRadioboxStyle,
	style
];
